<template>
  <div>
    <!-- 契約modal -->
    <b-modal
    id="contract-modal"
    ref="contract-modal"
    :title="isNew ? '新增契約' : `修改契約-${data.number}`"
    size="xl"
    centered
    hide-footer
    header-class="head-modal"
    :no-close-on-backdrop="true"
    v-model="modalShow"
  >
    <b-card
      border-variant="secondary"
      header="安家寶專案要助書"
      header-border-variant="secondary"
      header-bg-variant="secondary"
      header-text-variant="white"
      align="left"
      class="mb-4"
    >
      <div class="row align-items-center">
        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="加入方案" class="star">
            <b-form-checkbox-group
              class="d-flex align-items-center h-100"
              v-model="data.plan"
              :options="optionsPlan"
            ></b-form-checkbox-group>
            <!-- <b-form-radio-group
              v-model="data.plan"
              :options="options.plan"
            ></b-form-radio-group> -->
          </b-form-group>
        </div>

        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="使用推薦生命禮儀" class="star">
            <b-form-checkbox switch size="lg" value=1 unchecked-value=0 v-model.number="data.recommend"></b-form-checkbox>
          </b-form-group>
        </div>
      </div>

      <b-form-group label-cols="auto" label-cols-lg="auto" label="入會日期" class="star">
        <date-picker
          v-model="data.join_date"
          :position="'left'"
          :max="getTodayDate()"
        ></date-picker>
        <!-- <b-form-datepicker v-model="data.join_date"></b-form-datepicker> -->
      </b-form-group>
    </b-card>

    <b-card
      border-variant="success"
      header="要助人(繳費者)"
      header-border-variant="success"
      header-bg-variant="success"
      header-text-variant="white"
      align="left"
      class="mb-4"
    >
      <b-form-group label-cols="auto" label-cols-lg="auto" label="姓名" class="star">
        <b-form-input v-model="data.pay_name"></b-form-input>
      </b-form-group>

      <div class="row align-items-center">
        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="出生日期" class="star">
            <date-picker
              v-model="data.pay_birthday"
              :position="'left'"
              :manualInput="true"
              placeholder="手動輸入時中間符號不用輸入，打數字即可，日期格式：065-02-26"
            ></date-picker>
            <!-- <b-form-datepicker v-model="data.pay_birthday"></b-form-datepicker> -->
          </b-form-group>
        </div>

        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="身分證字號" class="star">
            <b-form-input v-model="data.pay_ID_number"></b-form-input>
          </b-form-group>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="市話">
            <b-form-input type="text" v-model="data.pay_phone"></b-form-input>
          </b-form-group>
        </div>

        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="行動電話">
            <b-form-input type="text" v-model="data.pay_cellphone"></b-form-input>
          </b-form-group>
        </div>
      </div>

      <b-form-group label-cols="auto" label-cols-lg="auto" label="戶籍郵遞區號">
        <b-form-input v-model="data.pay_HpostalCode"></b-form-input>
      </b-form-group>

      <b-form-group label-cols="auto" label-cols-lg="auto" label="戶籍地址">
        <b-form-input v-model="data.pay_Haddress"  @change="changeAddress('pay_HpostalCode', data.pay_Haddress)"></b-form-input>
      </b-form-group>

      <div class="d-flex align-items-center mb-3">
        <b-form-group label-cols="auto" label-cols-lg="auto" label="通訊郵遞區號" class="mb-0">
          <b-form-input v-model="data.pay_CpostalCode"></b-form-input>
        </b-form-group>

        <b-button
          class="ml-2"
          variant="primary"
          size="sm"
          @click="syncData(['pay_Caddress', 'pay_Haddress'], ['pay_CpostalCode', 'pay_HpostalCode'])"
        >
          同戶籍地址
        </b-button>
      </div>

      <b-form-group label-cols="auto" label-cols-lg="auto" label="通訊地址">
        <b-form-input v-model="data.pay_Caddress" @change="changeAddress('pay_CpostalCode', data.pay_Caddress)"></b-form-input>
      </b-form-group>

      <div class="d-flex align-items-center mb-3">
        <b-form-group label-cols="auto" label-cols-lg="auto" label="帳單郵遞區號" class="mb-0">
          <b-form-input v-model="data.pay_BpostalCode"></b-form-input>
        </b-form-group>

        <b-button
          class="ml-2"
          variant="primary"
          size="sm"
          @click="syncData(['pay_Baddress', 'pay_Haddress'], ['pay_BpostalCode', 'pay_HpostalCode'])"
        >
          同戶籍地址
        </b-button>

        <b-button
          class="ml-2"
          variant="success"
          size="sm"
          @click="syncData(['pay_Baddress', 'pay_Caddress'], ['pay_BpostalCode', 'pay_CpostalCode'])"
        >
          同通訊地址
        </b-button>
      </div>

      <b-form-group label-cols="auto" label-cols-lg="auto" label="帳單地址" class="star">
        <b-form-input v-model="data.pay_Baddress" @change="changeAddress('pay_BpostalCode', data.pay_Baddress)"></b-form-input>
      </b-form-group>
    </b-card>

    <b-card
      border-variant="success"
      header="自動扣款"
      header-border-variant="success"
      header-bg-variant="success"
      header-text-variant="white"
      align="left"
      class="mb-4"
    >
      <b-form-group label-cols="auto" label-cols-lg="auto" label="姓名">
        <b-form-input v-model="data.pay_auto_name"></b-form-input>
      </b-form-group>

      <b-form-group label-cols="auto" label-cols-lg="auto" label="身分證">
        <b-form-input v-model="data.pay_auto_ID_number"></b-form-input>
      </b-form-group>

      <b-form-group label-cols="auto" label-cols-lg="auto" label="郵局帳號">
        <b-form-input v-model="data.pay_bank_account"></b-form-input>
      </b-form-group>

      <b-form-group label-cols="auto" label-cols-lg="auto" label="申請日期">
        <date-picker
          v-model="data.pay_auto_date"
          :position="'left'"
          :manualInput="true"
          placeholder="手動輸入時中間符號不用輸入，打數字即可，日期格式：065-02-26"
        ></date-picker>
      </b-form-group>
    </b-card>

    <b-card
      border-variant="primary"
      header="互助人(會員)"
      header-border-variant="primary"
      header-bg-variant="primary"
      header-text-variant="white"
      align="left"
      class="mb-4"
    >
      <div class="d-flex align-items-center mb-3">
        <b-form-group label-cols="auto" label-cols-lg="auto" label="姓名" class="mb-0 star">
          <b-form-input v-model="data.member_name"></b-form-input>
        </b-form-group>

        <b-button
          class="ml-2"
          variant="primary"
          size="sm"
          @click="syncData(['member_name', 'pay_name'], ['member_birthday', 'pay_birthday'], ['member_ID_number', 'pay_ID_number'], ['member_relation', '本人'])"
        >
          同要助人
        </b-button>
      </div>

      <div class="row align-items-center">
        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="出生日期" class="star">
            <date-picker
              v-model="data.member_birthday"
              :position="'left'"
              :manualInput="true"
              placeholder="手動輸入時中間符號不用輸入，打數字即可，日期格式：065-02-26"
            ></date-picker>
            <!-- <b-form-datepicker v-model="data.member_birthday"></b-form-datepicker> -->
          </b-form-group>
        </div>

        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="身分證字號" class="star">
            <b-form-input
              v-model="data.member_ID_number"
              :state="memberIDNumberVerifyStatus"
              @change="verifyMemberIDNumber"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="與要助人之關係">
            <b-form-input v-model="data.member_relation"></b-form-input>
          </b-form-group>
        </div>

        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="身分證明文件">
            <b-form-checkbox switch size="lg" value=1 unchecked-value=0 v-model.number="data.member_isID"></b-form-checkbox>
          </b-form-group>
        </div>
      </div>
    </b-card>

    <b-card
      border-variant="dark"
      header="互助金受款人"
      header-border-variant="dark"
      header-bg-variant="dark"
      header-text-variant="white"
      align="left"
      class="mb-4"
    >
      <div class="d-flex align-items-center mb-3">
        <b-form-group label-cols="auto" label-cols-lg="auto" label="姓名" class="mb-0">
          <b-form-input v-model="data.beneficiary_name"></b-form-input>
        </b-form-group>

        <b-button
          class="ml-2"
          variant="primary"
          size="sm"
          @click="syncData(['beneficiary_name', 'pay_name'], ['beneficiary_birthday', 'pay_birthday'], ['beneficiary_ID_number', 'pay_ID_number'], ['beneficiary_phone', 'pay_phone'], ['beneficiary_cellphone', 'pay_cellphone'], ['beneficiary_relation', 'member_relation'])"
        >
          同要助人
        </b-button>
      </div>

      <div class="row align-items-center">
        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="出生日期">
            <date-picker
              v-model="data.beneficiary_birthday"
              :position="'left'"
              :manualInput="true"
              placeholder="手動輸入時中間符號不用輸入，打數字即可，日期格式：065-02-26"
            ></date-picker>
            <!-- <b-form-datepicker v-model="data.beneficiary_birthday"></b-form-datepicker> -->
          </b-form-group>
        </div>

        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="身分證字號">
            <b-form-input v-model="data.beneficiary_ID_number"></b-form-input>
          </b-form-group>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="市話">
            <b-form-input type="text" v-model="data.beneficiary_phone"></b-form-input>
          </b-form-group>
        </div>

        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="行動電話">
            <b-form-input type="text" v-model="data.beneficiary_cellphone"></b-form-input>
          </b-form-group>
        </div>
      </div>

      <b-form-group label-cols="auto" label-cols-lg="auto" label="與互助人之關係">
        <b-form-input v-model="data.beneficiary_relation"></b-form-input>
      </b-form-group>
    </b-card>

     <b-card
      border-variant="dark"
      header="祝壽金受益人"
      header-border-variant="dark"
      header-bg-variant="dark"
      header-text-variant="white"
      align="left"
      class="mb-4"
    >
      <div class="d-flex align-items-center mb-3">
        <b-form-group label-cols="auto" label-cols-lg="auto" label="姓名" class="mb-0">
          <b-form-input v-model="data.gift_name"></b-form-input>
        </b-form-group>

        <b-button
          class="ml-2"
          variant="primary"
          size="sm"
          @click="syncData(['gift_name', 'pay_name'], ['gift_ID_number', 'pay_ID_number'], ['gift_cellphone', 'pay_cellphone'])"
        >
          同要助人
        </b-button>
      </div>

      <div class="row align-items-center">
        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="身分證字號">
            <b-form-input v-model="data.gift_ID_number"></b-form-input>
          </b-form-group>
        </div>

        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="行動電話">
            <b-form-input type="text" v-model="data.gift_cellphone"></b-form-input>
          </b-form-group>
        </div>
      </div>

      <div class="d-flex row align-items-center">
        <div class="col-12">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="銀行帳號">
            <b-form-input v-model="data.gift_bank_account"></b-form-input>
          </b-form-group>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="銀行代碼">
            <b-form-input type="text" v-model="data.gift_bankCode" @change="changeBankCode"></b-form-input>
          </b-form-group>
        </div>

        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="銀行名稱">
            <b-form-input type="text" v-model="data.gift_bank"></b-form-input>
          </b-form-group>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="分行代碼">
            <b-form-input type="text" v-model="data.gift_branchCode" :disabled="!status.checkBranchCode" @change="changeBranchCode"></b-form-input>
          </b-form-group>
        </div>

        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="分行名稱">
            <b-form-input type="text" v-model="data.gift_branch" :disabled="!status.checkBranchCode"></b-form-input>
          </b-form-group>
        </div>
      </div>
    </b-card>

    <b-card
      border-variant="warning"
      header="其他"
      header-border-variant="warning"
      header-bg-variant="warning"
      header-text-variant="white"
      align="left"
      class="mb-4"
    >
      <b-form-group label-cols="auto" label-cols-lg="auto" label="停止出帳單">
        <b-form-checkbox switch size="lg" value=1 unchecked-value=0 v-model.number="data.stop_bill"></b-form-checkbox>
      </b-form-group>

      <b-form-group label-cols="auto" label-cols-lg="auto" label="帳單領取方式">
        <b-form-select v-model="data.receive" :options="billReceiveMethod"></b-form-select>
      </b-form-group>

      <div class="d-flex align-items-center mb-4">
        <b-form-group label-cols="auto" label-cols-lg="auto" label="業務員編號" :class="['mb-0', {'star': !isNew}]">
          <b-form-input v-model="data.sales_number" readonly></b-form-input>
        </b-form-group>

        <b-form-input v-model="data.sales_name" class="w-25" readonly></b-form-input>

        <b-button
          class="ml-2"
          variant="primary"
          size="sm"
          @click="openBusinessModal"
        >
          搜尋業務員
        </b-button>
      </div>

      <b-form-group label-cols="auto" label-cols-lg="auto" label="愛心天使站服務人">
        <b-form-input type="text" v-model="data.servicer"></b-form-input>
      </b-form-group>

      <b-form-group label-cols="auto" label-cols-lg="auto" label="備註">
        <b-form-textarea
          v-model="data.remark"
          rows="3"
        />
      </b-form-group>
    </b-card>

    <b-card
      border-variant="info"
      header="會員領取日期"
      header-border-variant="info"
      header-bg-variant="info"
      header-text-variant="white"
      align="left"
      class="mb-4"
    >
      <b-form-group label-cols="auto" label-cols-lg="auto" label="領取日期">
        <date-picker
          v-model="data.pickup_at"
          :position="'left'"
        ></date-picker>
      </b-form-group>

      <b-form-group label-cols="auto" label-cols-lg="auto" label="領取備註">
        <b-form-textarea
          v-model="data.pickup_remark"
          rows="3"
        />
      </b-form-group>
    </b-card>

    <b-card
      border-variant="danger"
      header="身故"
      header-border-variant="danger"
      header-bg-variant="danger"
      header-text-variant="white"
      align="left"
      class="mb-4"
    >
      <div class="row align-items-center">
        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="下次互助名單">
            <b-form-checkbox switch size="lg" value=1 unchecked-value=0 v-model.number="data.help_check"></b-form-checkbox>
          </b-form-group>
        </div>

        <!-- <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="下次遞延名單">
            <b-form-checkbox switch size="lg" value=1 unchecked-value=0 v-model.number="data.deferred_check"></b-form-checkbox>
          </b-form-group>
        </div> -->
      </div>
    </b-card>

    <b-card
      border-variant="info"
      header="入會"
      header-border-variant="info"
      header-bg-variant="info"
      header-text-variant="white"
      align="left"
    >
      <div class="row align-items-center">
        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="是否繳費">
            <b-form-checkbox switch size="lg" value=1 unchecked-value=0 v-model.number="data.join_check"></b-form-checkbox>
          </b-form-group>
        </div>

        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="金額">
            <b-form-input v-model="data.join_amount"></b-form-input>
          </b-form-group>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="繳款來源">
            <b-form-select
              v-model="data.join_payment_source"
              :options="options.joinPaymentSource"
            >
              <template #first>
                <b-form-select-option :value="null" disabled>-- 請選擇 --</b-form-select-option>
              </template>
            </b-form-select>
          </b-form-group>
        </div>

        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="繳款時間">
            <date-picker
              v-model="data.join_payment_at"
              :position="'left'"
            ></date-picker>
          </b-form-group>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="發票">
            <b-form-input v-model="data.join_invoice"></b-form-input>
          </b-form-group>
        </div>

        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="匯款戶名">
            <b-form-input v-model="data.join_bank_name"></b-form-input>
          </b-form-group>
        </div>
      </div>

      <b-form-group label-cols="auto" label-cols-lg="auto" label="備註">
        <b-form-textarea
          v-model="data.join_remark"
          rows="3"
        />
      </b-form-group>
    </b-card>

    <div class="text-center mt-4">
      <b-button
        v-if="isEditable"
        v-auth="`update`"
        class="mr-2"
        variant="success"
        size="sm"
        @click="sumit()"
      >
        確定
      </b-button>
      <b-button
        variant="danger"
        size="sm"
        class="mr-4"
        @click="$bvModal.hide('contract-modal')"
      >
        取消
      </b-button>
    </div>
  </b-modal>

  <!-- 業務選擇modal -->
  <business-select-modal
    v-model="status.businessSelectModal"
    @select="selectSalesSystem" />
</div>
</template>

<script>
import TablesPage from "@/components/layouts/TablesPage";
import contractApi from "@/models/API/contractApi";
import datePicker from '@/components/common/DatePicker';
import { checkAgeLimit, validateTWID, verifyOldResidencePermit, getRocZipcode, getTodayDate } from "@/models/HELPERS/common.js";
import { billReceiveMethod } from "@/models/HELPERS/options.js";
import BusinessSelectModal from"./BusinessSelectModal";
import { BankCodes, BranchCodes } from "@/models/HELPERS/utilitiesData.js";

export default {
  name: 'ContractAddEditModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    data: {
      type: Object,
      required: false,
      default: () => {}
    },
    isNew: { // 是否為新增
      type: Boolean,
      required: false,
      default: true
    },
    isEditable: { // 是否可編輯
      type: Boolean,
      required: false,
      default: true
    },
  },
  components: {
    TablesPage,
    datePicker,
    BusinessSelectModal
  },
  data () {
    return {
      memberIDNumberVerifyStatus: null,
      memberIDNumberVerifySaveStatus: true,
      originalMemberIDNumber: '',
      options: {
        status: [
          { value: 0, text: '正常' },
          { value: 1, text: '失效' },
          { value: 2, text: '停權' },
        ],
        joinPaymentSource: [
          { value: '台中', text: '台中' },
          { value: '現金', text: '現金' },
        ],
      },
      status: {
        businessSelectModal: false,
        checkBranchCode: false
      },
      billReceiveMethod
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
    optionsPlan() {
      return [
        {
          value: 'A',
          text: '永保20',
          disabled: !this.isNew || (this.isNew && this.data.existing_plan.some(item => item === 'A'))
        },
        {
          value: 'B',
          text: '長安30',
          disabled: !this.isNew || (this.isNew && this.data.existing_plan.some(item => item === 'B'))
        },
      ];
    }
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        this.memberIDNumberVerifyStatus = null;
        this.originalMemberIDNumber = this.data.member_ID_number || '';
        this.initCheckBankCodesStatus();
      },
      immediate: false
    },
    // 'data.help_check': {
    //   handler(newValue, oldValue) {
    //     if (newValue === 1) {
    //       this.data.deferred_check = 0;
    //     }
    //   },
    //   immediate: false
    // },
    // 'data.deferred_check': {
    //   handler(newValue, oldValue) {
    //     if (newValue === 1) {
    //       this.data.help_check = 0;
    //     }
    //   },
    //   immediate: false
    // }
  },
  mounted() {
    this.contractApi = new contractApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {

    },
    getTodayDate,
    // 初始化，檢查分行代碼狀態(編輯時 不檢查)
    initCheckBankCodesStatus() {
      this.status.checkBranchCode = !this.isNew;
    },
    sumit() {
      try {
        let required =
          ['plan',
          'recommend',
          'join_date',
          'pay_name',
          'pay_birthday',
          'pay_ID_number',
          'pay_Baddress',
          'member_name',
          'member_birthday',
          'member_ID_number'];

        if (!this.isNew) required.push('sales_number');

        const data = this.data;
        const status = required.every(item => {
          return Array.isArray(data[item]) ? data[item].length !== 0 : data[item] != null && data[item] !== '';
        });

        if (!status) {
          throw { message: '欄位請填寫完整', title: '契約' };
        } else if (!checkAgeLimit(data.pay_birthday)) {
          throw { message: '要助人須滿18歲', title: '契約' };
        } else if (!checkAgeLimit(data.member_birthday)) {
          throw { message: '互助人須滿18歲', title: '契約' };
        } else if (!validateTWID(this.data.pay_ID_number) && !verifyOldResidencePermit(this.data.pay_ID_number)) {
          throw { message: '要助人身分證字號，不符合格式', title: '契約' };
        } else if (!validateTWID(this.data.member_ID_number) && !verifyOldResidencePermit(this.data.member_ID_number)) {
          throw { message: '互助人身分證字號，不符合格式', title: '契約' };
        } else if (!this.memberIDNumberVerifySaveStatus && (this.originalMemberIDNumber !== this.data.member_ID_number)) {
          throw { message: '互助人身分證之前有加入過', title: '契約' };
        }

        this.$emit('sumit');
      } catch(message) {
        this.contractApi.toast(() => {}, message, false);
      }
    },
    selectSalesSystem(item) {
      this.$set(this.data, 'sales_id', item.id);
      this.$set(this.data, 'sales_number', item.number);
      this.$set(this.data, 'sales_name', item.name);

      this.status.businessSelectModal = false;
    },
    // 同步資料
    syncData(...sync_item) {
      sync_item.forEach(item => {
        // this.$set(this.data, item[0], typeof this.data[item[1]] !== 'undefined' ? this.data[item[1]] : item[1]);
        if (item[1] === '本人') {
          this.$set(this.data, item[0], '本人');
        } else {
          this.$set(this.data, item[0], this.data[item[1]]);
        }
      })
    },
    // 開啟業務員modal
    openBusinessModal() {
      this.status.businessSelectModal = true;
    },
    // 驗證互助人身分證是否之前有加入過
    verifyMemberIDNumber() {
      if (!this.data.member_ID_number || this.data.member_ID_number.length !== 10 || this.originalMemberIDNumber === this.data.member_ID_number) {
        this.memberIDNumberVerifyStatus = null;
        this.memberIDNumberVerifySaveStatus = true;
        return;
      }

      const params = {
        'member_ID_number': this.data.member_ID_number,
      };
      this.contractApi.getMember((response) => {
        const res = response.data;

        this.memberIDNumberVerifyStatus = res.data.length === 2 ? false : true;
        this.memberIDNumberVerifySaveStatus = res.data.length === 2 ? false : true;
      }, params, false)
    },
    // 改變地址，自動帶入郵遞區號
    changeAddress(postalCode_key, address) {
      this.$set(this.data, postalCode_key, getRocZipcode(address));
    },
    // 更改銀行代碼
    changeBankCode() {
      const bank_codes = BankCodes.find(item => item.code === this.data.gift_bankCode);

      if (bank_codes) {
        this.$set(this.data, 'gift_bank', bank_codes.name.trim());
        this.status.checkBranchCode = true;
      } else {
        const result = { message: '銀行代碼錯誤', title: '契約' };
        this.contractApi.toast(() => {}, result, false);

        this.status.checkBranchCode = false;
        this.data.gift_bank = '';
      }

      this.data.gift_branchCode = '';
      this.data.gift_branch = '';
      this.$forceUpdate();
    },
    // 更改分行代碼
    changeBranchCode() {
      const branch_codes = BranchCodes[this.data.gift_bankCode].find(item => item.code === `${this.data.gift_bankCode}${this.data.gift_branchCode}`)

      if (branch_codes) {
        this.$set(this.data, 'gift_branch', branch_codes.name.trim());
      } else {
        const result = { message: '分行代碼錯誤', title: '契約' };
        this.contractApi.toast(() => {}, result, false);

        this.data.gift_branch = '';
      }

      this.$forceUpdate();
    },
  }
}
</script>

<style lang="scss" scoped>
.star {
  position: relative;
  &:before {
    content: "*";
    color: red;
    position: absolute;
    top: 50%;
    left: -10px;
    transform: translateY(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/components/modal/ContractAddEditModal.vue